const Form079EN = {
    stepName: {
        importantNotes: "Important Notes",
        organisationInfo: "Organisation Info",
        venuesAddress: "Venues Address",
        declaration: "Declaration",
        confirmation: "Confirmation",
    },
    title: "Application for Operation of Induction Programme for Newly Arrived Children in the {{financialYear}} financial year",
    formBoxTitle: {
        notes: "Notes",
        note: "Note",
        forward:
            "I forward herewith an application for operation of the Induction Programme for Newly Arrived Children in the {{financialYear}} financial year. Please find attached the completed form for the information of our organisation. I declare that to the best of my knowledge, the information contained in this application is true and correct.",
        organisation: "Information of the Organisation",
        organInfo: "Organisation Information",
        organOption: {
            one: "I. Organisation",
            two: "II. Owner/Operator",
            three: "III. Contact Person",
            four: "IV. Full Address(es) of the Venue(s) under Application",
            partA: "Part A: Using <u><b>“premises not designed and constructed as a school”</b></u> as venues",
            partB: "Part B: Using <u><b>school premises</b></u> as venues",
            five: "V. Declaration by Owner/Operator",
        },
        pic: "Personal Information Collection Statement",
    },

    organisation: {
        ordinanceAttachment:
            "Attachment: Copies of relevant documents certifying that the Organisation is an approved charitable institution of a public character under Section 88 of the Inland Revenue Ordinance",
        title: {
            t1: "Main Office Bearers and Chief Executives",
            t2: "Note: Please list below the projects/programmes / activities which were organised for new arrivals by your organisation in the past two years and attach copies of relevant supporting documents to this application",
            t3: "Experience of Organising Programmes /Activities",
        },
        nameE: "Name of Organisation in English",
        nameC: "Name of Organisation in Chinese",
        addressE: "Address of Organisation in English",
        addressC: "Address of Organisation in Chinese",
        tel: "Telephone No.",
        fax: "Fax No.",
        chairDirect: "Chairman/Director",
        accTreasurer: "Accountant/Treasurer",
        cdOption: {
            chairman: "Chairman",
            director: "Director",
        },
        atOption: {
            accountant: "Accountant",
            treasurer: "Treasurer",
        },
        englishName: "English Name",
        chineseName: "Chinese Name",
        englishInName: "Name in English",
        chineseInName: "Name in Chinese",
        telNo: "Telephone No.",
        adminNameE:
            "Name of Programme Administrator and Contact Person(English)",
        adminNameC:
            "Name of Programme Administrator and Contact Person(Chinese)",
        object: "Objectives of the Organisation",
        nature: "Nature of projects/programmes / activities(e.g. personal development, family life education, social adaptation, etc.)",
        target: "Target participants(e.g.newly arrived children, newly arrived adults, etc)",
        dateFrom: "Date From",
        dateTo: "Date To",
        duration: "Period",
        // year: "year",
        months: "month",
        natureAttachment: "Attachment: supporting documents",
        nonProfit: "Non-profit making",
        yes: "Yes",
        no: "No",
        profitAttach:
            "Attachment: document (e.g. letter from Inland Revenue Department) giving evidence that the organisation is a non-profit- making charitable incorporated body",
        // guide: "Ad ministrative Guide",
        guide: "Induction Programme for Newly Arrived Children Administrative Guide ({{financialYear}} Financial Year)",
        email: "Email address",
    },
    note: "Application for Exemption from Registration As a School (Revised in {{revisionDate}})",
    organOne: {
        nameE: "Name in English",
        nameC: "Name in Chinese",
        addressE: "Address in English",
        addressC: "Address in Chinese",
        tel: "Telephone No.",
        fax: "Fax No.",
    },
    organTwo: {
        appTitle: "Title",
        appTitleOption: {
            mr: "Mr",
            ms: "Ms",
        },
        nameE: "Name in English",
        nameC: "Name in Chinese",
        addressEn: "Address in English",
        addressCh: "Address in Chinese",
        idNo: "ID Card No.",
        telephoneNo: "Telephone No.",
        faxNo: "Fax No.",
        facsimile: "Facsimile No.",
    },
    organThree: {
        name: "Name",
        post: "Post",
        corrAddress: "Correspondence Address",
        telNoT: "Tel. No",
    },
    organFour: {
        venuesAddress: "Please select the corresponding address",
        venuesOption: {
            builtVenues:
                "Part A: Using <u><b>“premises not designed and constructed as a school”</b></u> as venues",
            schoolVenues:
                "Part B: Using <u><b>school premises</b></u> as venues",
        },
    },
    venues: {
        topic: {
            t1: "Please complete Part A if the programme is operated at the <u>premises not designed and constructed as a school (premises at commercial or mixed commercial residential building)</u>. Programme Administrator has to ensure that the venue concerned satisfies the following requirements -",
            t2: "• venue shall not be situated at a height of more than 24m above the ground level",
            t3: "• venue shall not be situated on an upper floor of a single staircase building",
            t4: "venue shall not be situated in a factory, warehouse, cinema or premises whereby the undertakings therein may endanger the lives or safety of students",
            t5: "• venue shall not have any unauthorised building works",
            t6: "• a minimum of two exits shall be provided for any room or storey which can accommodate more than 30 persons",
            t7: "• venue shall not be an unregistered school",
            t8: "[School Heads concerned are required to complete the letter of authorisation (Appendix Ia)]",
            t9: "Please complete Part B if the programme is operated at school premises.",
            t10: "Please use a separate sheet if space below is not enough.",
            t11: "Section 9(5) of the Education Ordinance stipulates that -",
            t12: "The Permanent Secretary may, by order in writing, exempt from all or any of the provisions of this Ordinance- (Amended 3 of 2003 s.11)",
            t13: "any school which provides education consisting only of a series of lectures, or a course of instruction in a particular subject or topic;",
            t14: "any school which provides less than 10 hours of academic instruction each week; and",
            t15: "the interested persons of any school referred to in paragraph (a) or (b), on such conditions, if any,as he thinks fit.",
            t16: "[Please attach valid documents to certify the premises concerned fulfill the relevant fire safety requirements in the exemption period, e.g., F.S. 251 – Certificate of Fire Service Installations and Equipment.]",
        },
        certificate:
            "Attachment: Certificate of Fire Service Installations and Equipment",
        centreName: "Centre Name",
        address: "Address",
        downloadAppendix: "Download Appendix Ia Form",
        schoolName: "School Name",
        appendix: "Attachment: Appendix Ia",
        consentForm: "Consent form",
        periodDate: "Period of Exemption Applied for",
        from: "From",
        to: "To",
    },
    label: {
        noteList: {
            note1: "Copies of relevant documents certifying that the Organisation is an approved charitable institution of a public character under Section 88 of the Inland Revenue Ordinance must be attached to this application.",
            note2: "The personal data provided by means of this form will be used for the purpose of processing application for subvention to operate the Induction Programme for Newly Arrived Children in the {{financialYear}} financial year only. Enquiries concerning the personal data collected by means of this form including the making of access and correction should be addressed to -",
        },
        noteList1: {
            note3: "Assistant Education Officer (Placement and Support)",
            note4: "Newly Arrived Children Support Unit",
            note5: "Room 1424, 14/F, Wu Chung House",
            note6: "213 Queen’s Road,Wan Chai, Hong Kong",
            note7: "Tel : 2892 6189",
        },
        noteList2: {
            note8: "Please complete Part A if the programme is operated at the venues situated in non-purpose-built premises not designed and constructed as a school.",
            note9: "Please complete Part B if the programme is operated at school premises.",
            note10: "Please use a separate sheet if space below is not enough.",
            note11: "Section 9(5) of the Education Ordinance stipulates that-",
        },
        listNum: {
            note8: "1.",
            note9: "2.",
            note10: "3.",
            note11: "4.",
        },
        noteList3: {
            note12: "The Permanent Secretary may, by order in writing, exempt from all or any of the provisions of this Ordinance-(Amended 3 of 2003 s.11)",
            note14: "any school which provides education consisting only of a series of lectures, or a course of instruction in a particular subject or topic;",
            note15: "any school which provides less than 10 hours of academic instruction each week; and",
            note16: "  the interested persons of any school referred to in paragraph (a) or (b),",
            note17: '<p style="margin-left:20px;">on such conditions, if any, as he thinks fit.</p>',
        },
        noteList3Num: {
            note14: "(a)",
            note15: "(b)",
            note16: "(c)",
        },
        noteList4: {
            //note17: "I have/have not* been convicted of a /any criminal offence;",
            note17: "I ",
            note19: " been convicted of a /any criminal offence;",
            note18: "I declare that the contents of this application are true and complete to the best of my knowledge and belief.",
        },
        noteList4Num: {
            note17: "(i) ",
            note18: "(ii) ",
        },
    },

    offenceOption: {
        have: "have",
        haveNot: "have not",
    },

    name: "Name",

    organName: "Organisation",
    applicantName: "Applicant's Name",
    position: "Position",
    chopAttachment: "Attachment: Official Chop",
    date: "Date",
    proContent: "Suggested Programme Content",
    financialYear: "Financial year",

    errorMsg: {
        telMax: "Telephone number must be at most 12 digits",
    },
    picNote: {
        note1: {
            title: `The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:`,
            subtitle: "Purpose of Collection",
            content1:
                "Activities relating to the processing, authentication and counter-checking of the application for the operation of Induction Programme for Newly Arrived Children;",
            content2:
                "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above; ",
            content3:
                "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
            content4:
                "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
            content5:
                "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits; ",
            content6:
                "Activities relating to compilation of statistics, research and Government publications; and",
            content7:
                "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules) and the Codes of Aid.",
        },
        note2: {
            title: `The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.`,
        },
        note3: {
            title: `The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-`,
            subtitle: "Classes of Transferees",
            content1:
                "other Government bureaux and departments, for the purposes mentioned in paragraph 1 above; ",
            content2:
                "the school to which the form relates for the purposes mentioned in paragraph 1 above;",
            content3:
                "where you have given your prescribed consent to such disclosure; and",
            content4:
                "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
        note4: {
            title: `You have the right to request access to and correction of your personal data held by EDB.  Request for access to or correction of personal data should be made in writing to Assistant Education Officer (Placement and Support)32 at Room 1424, 14/F, Wu Chung House, 213 Queen’s Road East, Wanchai, Hong Kong or email to aeops32@edb.gov.hk.`,
            subtitle: "Access to Personal Data",
        },
    },
    formExpired: "This form is under maintenance. You might not submit it.",
};

export default Form079EN;
